import React from 'react';
import { navigate } from 'gatsby';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMore from '@material-ui/icons/ExpandMore';

const ProductMenu = withStyles((theme) => ({
    paper: {
        backgroundColor: theme.palette.primary.main,
    },
}))((props) => (
    <Menu
        autoFocus={false}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        {...props}
    />
));

const ProductMenuItem = withStyles((theme) => ({
    root: {
        '&:hover': {
            color: theme.palette.secondary.main,
        },
        color: theme.palette.primary.contrastText,
    },
}))(MenuItem);

class ProductSelector extends React.Component {
    state = {
        anchorEl: null,
    };

    handleOpen = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = (value) => {
        this.setState({ anchorEl: null });
        if (value != null) {
            this.props.handleDrawerToggle();
            navigate(`/${value}`);
        }
    };

    render() {
        const { classes, selectedProduct } = this.props;

        return (
            <span>
                <Button
                    aria-controls="product-menu"
                    aria-haspopup="true"
                    color="inherit"
                    onClick={this.handleOpen}
                    classes={{ root: classes }}
                >
                    Product
                    <ExpandMore />
                </Button>
                <ProductMenu
                    id="product-menu"
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={() => this.handleClose(null)}
                >
                    {[
                        ['Home', ''],
                        ['Media Shuttle', 'media-shuttle'],
                        ['Jet', 'jet'],
                        ['Manager+Agents', 'manager-agents'],
                        ['Flight', 'flight'],
                    ].map((item) => (
                        <ProductMenuItem
                            onClick={() => this.handleClose(item[1])}
                            selected={selectedProduct === item[1]}
                        >
                            {item[0]}
                        </ProductMenuItem>
                    ))}
                </ProductMenu>
            </span>
        );
    }
}

export default ProductSelector;
